import { AlertColor } from '@mui/material';
import { makeAutoObservable } from 'mobx';

class NotificationStore {
  message = '';
  detail = {};
  severity: AlertColor = 'info';
  open = false;

  constructor() {
    makeAutoObservable(this);
  }

  showMessage(text: any, severity: AlertColor = 'info', detail = {}) {
    this.message = text;
    this.detail = detail;
    this.severity = severity;
    this.open = true;
  }

  closeMessage() {
    this.open = false;
  }
}

export const notificationStore = new NotificationStore();
